import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { BooleanEnum } from "src/app/constants/boolean-enum";
import { SvgMatType } from "src/app/constants/icons";
import { TableColumnType } from "src/app/constants/table";
import { BenefitSummaryList } from "src/app/models/benefit-summary";
import { TableColumn, TableTest } from "src/app/models/table";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-agent-sass-tables',
    templateUrl: './sass-tables.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassTablesComponent {

    public benefits: BenefitSummaryList;
    public tableColumns: TableColumn[];
    public tableData: TableTest[];
    public matTableData: MatTableDataSource<TableTest>;
    public matTableData2: MatTableDataSource<TableTest> = new MatTableDataSource<TableTest>();

    constructor(
        private helperService: HelperService,
    ){
        this.benefits = new BenefitSummaryList();
        this.benefits.summaryBenefitCards = [
            {
                uniqueID: "08b0f6ba-2508-4d23-8318-72dda148e501",
                categoryId: 1874,
                categoryForDisplay: "MEDICAL",
                materialIconName: "local_hospital",
                showCategory: true,
                enrollmentName: "UHC FREEDOM PPO - 123",
                tier: "EMPLOYEE ONLY",
                effectiveDate: "12/01/2023",
                terminationDate: "",
                deductionForDisplay: "$51.92 W",
                deductionAmount: 51.92,
                processInfo: "",
                isPretax: true,
                isTermed: false,
                frequency: 52,
                enrollRequestId: -2147483648,
                showModal: true,
                coveredMembers: [
                    {
                    name: "SANDRA J ACEVES",
                    relationship: "MEMBER",
                    effectiveDate: "12/01/2023",
                    terminationDate: "",
                    processInfo: "",
                    disabledMessage: ""
                    }
                ],
                requestedEOIs: []
            }
        ];
        this.benefits.summaryTotalCards = [
            {
                totalPretax: 51.92,
                totalPosttax: 19.62,
                totalCost: 71.54,
                frequencyDisplay: "WEEKLY",
                frequency: 52
            }
        ];
        this.benefits.showSummaryTotal = true;

        this.tableColumns = [
            {
                columnName: '',
                propertyId: 'checkBoxSelectAll',
                columnType: TableColumnType.checkBoxSelectAll
            },{
                columnName: 'Label',
                propertyId: 'label',
                columnType: TableColumnType.label
            },{
                columnName: 'Label & ToolTip',
                propertyId: 'labelAndToolTip',
                columnType: TableColumnType.labelAndToolTip,
                svgCustomName: SvgMatType.SmsFailed,
                toolTip: 'toolTipMessage',
                toolTipCSS: 'error',
                toolTipDisplayEnd: true,
            },{
                columnName: 'HyperLink',
                propertyId: 'hyperLink',
                columnType: TableColumnType.hyperLink,
                dataTypePropertyId: 'hyperLinkText',
            },{
                columnName: 'Slide Toggle',
                propertyId: 'slideToggle',
                columnType: TableColumnType.slideToggle,
                dataTypeText: 'slideToggleText',
            },{
                columnName: 'Button Toggle',
                propertyId: 'buttonToggle',
                columnType: TableColumnType.buttonToggle,
                listArray: this.helperService.convertEnumToList(BooleanEnum),
            },{
                columnName: 'Icon Button',
                propertyId: 'iconButton',
                columnType: TableColumnType.iconButton,
                svgCustomName: SvgMatType.AccountTree,
            },{
                columnName: 'Button',
                propertyId: 'button',
                columnType: TableColumnType.button,
                dataTypeText: 'Test',
            }
        ];

        this.tableData = [
            {
                checkBoxSelectAll: false,
                checkBox: false,
                button: "Test 1",
                label: 'Test 1 Label',
                labelAndToolTip: 'Yuep',
                toolTipMessage: 'Why Is This Happening',
                input: '',
                hyperLink: 'OK',
                hyperLinkText: 'Hyper Test',
                buttonToggle: 'Y',
                iconButton: '',
                slideToggle: false,
                slideToggleText: 'Add',
                dropDown: 5,
            },{
                checkBoxSelectAll: false,
                checkBox: false,
                button: "Test 2",
                label: 'Test 2 Label',
                labelAndToolTip: 'Another Row',
                toolTipMessage: 'Alright',
                input: '',
                hyperLink: 'OK',
                hyperLinkText: 'Hyper Test 2',
                buttonToggle: 'N',
                iconButton: '',
                slideToggle: true,
                slideToggleText: 'Term',
                dropDown: 5,
            },{
                checkBoxSelectAll: false,
                checkBox: false,
                button: "Test 3",
                label: 'Test 3 Label',
                labelAndToolTip: 'Final Row',
                toolTipMessage: 'Alright',
                input: '',
                hyperLink: 'OK',
                hyperLinkText: 'Hyper Test 3',
                buttonToggle: '',
                iconButton: '',
                slideToggle: true,
                slideToggleText: 'Required',
                dropDown: 5,
            }
        ];

        this.matTableData = new MatTableDataSource<TableTest>();
        this.matTableData.data = this.tableData;
    }

    
}